import { Button, Input, Space, Table, Typography, Tabs, Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import ordersStorage from "../../../storages/orders.storage";
import styles from "../orders-page.module.scss";
import { IOrder, IOrderedItem } from "@drone-parts.garphild.pro/interfaces";
import DronesWithOrderedItems from './DronesWithOrderedItems';
import { PartTypeSelector } from "../../../components/part-type-selector";
import ShortName from "./short-name";


let timeout: any;
function debounce(func: any, wait: number) {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(func, wait);
}

function DetailTable({ order }: { order: IOrder }) {
  const itemsTotal = order.orderItems.reduce((acc, item) => acc + (item.itemPrice || 0) * +(item.itemQuantity || '1'), 0);
  const priceReduction = order.orderTotal / itemsTotal;
  return (
    <Tabs
      defaultActiveKey="1"
      type="card"
    >
      <Tabs.TabPane tab="Ordered items" key="orderedItems">
        <Table
          rowKey={order._id}
          key={order._id}
          className={styles['table']}
          rowClassName={(orderedItem, index) => {
            const inStock = orderedItem.received;
            const notInStock = !orderedItem.received;
            if (inStock && notInStock) {
              return styles['partially-in-stock'];
            }
            if (inStock) {
              return styles['in-stock'];
            }
            return styles['not-in-stock'];
          }}
          columns={[
            {
              title: "_id",
              dataIndex: "_id",
              key: "_id",
            },
            {
              title: "item name",
              dataIndex: "itemText",
              key: "itemText",
              render: (name, rowData, index) => {
                return (
                  <>
                    <ShortName orderedItem={{
                      ...rowData,
                      orderId: order.orderId,
                      marketplaceId: order.marketplaceId,
                      index,
                    }} />
                    <hr />
                    <Space>
                      <PartTypeSelector
                        partType={rowData.partTypes ? rowData.partTypes : []}
                        onChange={(value) => ordersStorage.setItemField(order.orderId, order.marketplaceId, rowData._id, value, 'partTypes')}
                      />
                    </Space>
                    <hr />
                    <Space>
                      {rowData.partVariants?.map((variant, index) => {
                        return (
                          <Checkbox
                            checked={rowData.partTypes?.includes(variant)}
                            onChange={(e) => {
                              const partTypes = e.target.checked
                                ? [...(rowData.partTypes || []), variant]
                                : (rowData.partTypes || []).filter((partType) => partType !== variant);
                              ordersStorage.setItemField(order.orderId, order.marketplaceId, rowData._id, partTypes, 'partTypes');
                            }}
                          >
                            {variant}
                          </Checkbox>
                        );
                      })}
                    </Space>
                  </>
                );
              }
            },
            {
              title: "variant",
              dataIndex: "itemVariant",
              key: "itemVariant",
            },
            {
              title: "itemQuantity",
              dataIndex: "itemQuantity",
              key: "itemQuantity",
              render: (quantity, rowData, index) => {
                return (
                  <Space direction="vertical" style={{whiteSpace: 'nowrap'}}>
                    <Typography>Qty: {quantity}</Typography>
                    <Typography>
                      Stock: {(rowData.inStock || 0) - (rowData.used?.reduce((acc, item) => acc + item.quantity, 0) || 0)}
                      <Input
                        value={rowData.inStock}
                        style={{
                          width: 100,
                        }}
                        onChange={(e) => {
                          debounce(() => {
                            ordersStorage.setItemField(order.orderId, order.marketplaceId, rowData._id, parseFloat(e.target.value), 'inStock');
                          }, 500);
                        }}
                      />
                    </Typography>
                    <Typography>Price: {rowData.itemPrice?.toFixed(2)}</Typography>
                    <Typography>Final price: {((rowData.itemPrice || 0) * priceReduction).toFixed(2)}</Typography>
                    <label
                      title="Units in package"
                    >
                      Units in package:<br />
                      <Input
                        defaultValue={rowData.unitsInPackage}
                        style={{
                          width: 100,
                        }}
                        onChange={(e) => {
                          debounce(() => {
                            ordersStorage.setItemField(order.orderId, order.marketplaceId, rowData._id, parseFloat(e.target.value), 'unitsInPackage');
                          }, 500);
                        }}
                      />
                    </label>
                  </Space>
                )
              }
            },
            {
              title: "Used",
              dataIndex: "used",
              key: "used",
              render: (parts: IOrderedItem['used']) => {
                return parts?.reduce((acc, part) => {
                    return acc + part.quantity
                  }, 0)
              }
            },
            {
              title: "Actions",
              dataIndex: "actions",
              key: "actions",
              render: (value: string, orderedItem, index ) => {
                return (
                  <>
                    <Button
                      onClick={() => ordersStorage.markReceived(order, orderedItem)}
                      disabled={!!orderedItem.received}
                    >
                      Received
                    </Button>
                    <Button
                      onClick={() => ordersStorage.markBroken(order, orderedItem)}
                      disabled={(orderedItem?.inStock || 0) <= (orderedItem?.used?.reduce((acc, item) => acc + item.quantity, 0) || 0)}
                    >
                      Broken
                    </Button>
                  </>
                )
              },
            }
          ]}
          dataSource={order?.orderItems || {}}
          pagination={false}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Drones" key="drones">
        <DronesWithOrderedItems order={order} />
      </Tabs.TabPane>
    </Tabs>
  );
}

export default observer(DetailTable);
